import { sidebarConfig } from '@backstage/core-components';
import { makeStyles } from '@material-ui/core';
import koneLogo from '../../assets/KONE_Logo_Primary_RGB.png';

// Intrinsic size of KONE_Logo_Primary_RGB.png is 4974 x 1924.
const LOGO_HEIGHT = 32;
const LOGO_WIDTH = (LOGO_HEIGHT * 4974) / 1924;

// SidebarLogo's link starts 24px from the sidebar's left edge.
const LINK_OFFSET_LEFT = 24;

// Horizontal shift that moves the logo's centre from its expanded position
// to the centre of the collapsed sidebar rail, so the rotated logo sits
// centred in the rail.
const COLLAPSED_SHIFT_X =
  sidebarConfig.drawerWidthClosed / 2 - (LINK_OFFSET_LEFT + LOGO_WIDTH / 2);

const useStyles = makeStyles({
  logo: {
    display: 'block',
    height: LOGO_HEIGHT,
    width: LOGO_WIDTH,
    transformOrigin: 'center center',
    // Matches the sidebar's own open/close timing (MUI "shorter" + "sharp").
    transition: 'transform 200ms cubic-bezier(0.4, 0, 0.6, 1)',
    willChange: 'transform',
    '@media (prefers-reduced-motion: reduce)': {
      transition: 'none',
    },
  },
  expanded: {
    transform: 'none',
  },
  collapsed: {
    // Rotate 90deg counter-clockwise so the logo reads bottom to top
    // (K at the bottom, E at the top).
    transform: `translateX(${COLLAPSED_SHIFT_X}px) rotate(-90deg)`,
  },
});

export const LogoFull = ({ isOpen }: { isOpen: boolean }) => {
  const classes = useStyles();

  return (
    <img
      src={koneLogo}
      alt="KONE"
      className={`${classes.logo} ${
        isOpen ? classes.expanded : classes.collapsed
      }`}
    />
  );
};
